import React from 'react';
import { View, Text } from 'react-native';
import { SVG_COMPONENTS } from '@/assets/admin';
import { ADMIN_COLORS } from '@/constants/admin';

export const TaskDetailsPill = ({ isBlocked, subtasks, files }: { isBlocked?: boolean; subtasks?: any[]; files?: any[] }) => {
  const hasSubtasks = !!(subtasks && subtasks.length);
  const completed = (subtasks || []).filter((s: any) => !!s.completedAt).length;
  const hasFiles = !!(files && files.length);
  if (!isBlocked && !hasSubtasks && !hasFiles) return null;

  return (
    <View style={{ flexDirection: 'row', alignItems: 'center', gap: 8, height: 24, paddingHorizontal: 8, borderRadius: 12, backgroundColor: 'rgba(255,255,255,0.06)', borderWidth: 1, borderColor: ADMIN_COLORS.BORDER }}>
      {isBlocked && (
        <SVG_COMPONENTS.WARNING width={14} height={14} color={ADMIN_COLORS.ERROR} />
      )}
      {hasSubtasks && (
        <View style={{ flexDirection: 'row', alignItems: 'center', gap: 4 }}>
          <SVG_COMPONENTS.FOLDER width={14} height={14} />
          <Text style={{ fontSize: 12, color: ADMIN_COLORS.TEXT_SECONDARY }}>{completed}/{subtasks!.length}</Text>
        </View>
      )}
      {hasFiles && (
        <View style={{ flexDirection: 'row', alignItems: 'center', gap: 4 }}>
          <SVG_COMPONENTS.PAPERCLIP width={14} height={14} />
          <Text style={{ fontSize: 12, color: ADMIN_COLORS.TEXT_SECONDARY }}>{files!.length}</Text>
        </View>
      )}
    </View>
  );
};


